import { Link } from "react-router-dom";
import { HiddenBadge } from "@/components/VisibilityToggle";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHead, StatusBadge } from "@/components/common";
import { Table, Td } from "@/pages/admin/AdminPages";
import { FullLoader } from "@/context/AuthContext";
import { api, errMsg, fmtDT, inr, useApi } from "@/lib/api";

export function AdminPartners() {
  const [status, setStatus] = useState("pending");
  const { data, loading, reload } = useApi(`/admin/partners${status !== "all" ? `?status=${status}` : ""}`);
  const orders = useApi("/admin/market-orders");
  const act = async (id, action) => {
    let notes = "";
    if (action !== "approve") {
      notes = window.prompt(action === "request_info" ? "What information do you need from the partner?" : "Reason (sent to the partner)") || "";
      if (!notes.trim()) return;
    }
    try { await api.post(`/admin/partners/${id}/decision`, { action, notes }); toast.success("Updated"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHead eyebrow="Suvidha Centre" title="Partners & orders" />
      <Tabs value={status} onValueChange={setStatus}><TabsList className="flex-wrap h-auto">{["pending", "more_info", "approved", "rejected", "suspended", "all"].map((s) => <TabsTrigger key={s} value={s} className="capitalize" data-testid={`partner-filter-${s}`}>{s === "more_info" ? "More info requested" : s}</TabsTrigger>)}</TabsList></Tabs>
      <div className="mt-4">{loading && !data ? <FullLoader /> : (
        <Table head={["Partner", "Type", "Licence details", "Listings", "Status", ""]} empty={data?.length === 0}>
          {data?.map((p) => (
            <tr key={p.id} data-testid={`admin-partner-row-${p.id}`}>
              <Td><p className="font-medium">{p.org_name}</p><p className="text-xs muted">{p.email} · {p.phone} · {p.city}</p></Td><Td className="capitalize">{p.partner_type}</Td>
              <Td className="text-xs">{Object.entries(p.details || {}).map(([k, v]) => <div key={k}>{k.replace(/_/g, " ")}: {v}</div>)}</Td>
              <Td>{p.listing_count}</Td><Td><StatusBadge status={p.status} /><Link to={`/admin/partners/${p.id}/edit`} className="ml-2 text-xs text-[#2412B5]" data-testid={`admin-partner-edit-${p.id}`}>Edit</Link><HiddenBadge hidden={p.hidden} testId={`admin-partner-hidden-${p.id}`} />
                {p.resubmitted_at && p.status === "pending" && <p className="text-[11px] text-[#2412B5] mt-1" data-testid={`partner-resubmitted-${p.id}`}>Resubmitted {fmtDT(p.resubmitted_at)}</p>}
                {p.notes && <p className="text-[11px] muted mt-1 max-w-[220px]" data-testid={`partner-note-${p.id}`}>Note: {p.notes}</p>}</Td>
              <Td><div className="flex flex-wrap gap-1">
                {p.status !== "approved" && <Button size="sm" onClick={() => act(p.id, "approve")} data-testid={`partner-approve-${p.id}`}>Approve</Button>}
                {p.status === "pending" && <Button size="sm" variant="outline" onClick={() => act(p.id, "request_info")} data-testid={`partner-request-info-${p.id}`}>Request info</Button>}
                {["pending", "more_info"].includes(p.status) && <Button size="sm" variant="outline" onClick={() => act(p.id, "reject")} data-testid={`partner-reject-${p.id}`}>Reject</Button>}
                {p.status === "approved" && <Button size="sm" variant="outline" onClick={() => act(p.id, "suspend")} data-testid={`partner-suspend-${p.id}`}>Suspend</Button>}
</div></Td>
            </tr>))}
        </Table>)}</div>
      <h3 className="font-semibold mt-10 mb-3">Suvidha Centre orders</h3>
      <Table head={["Order", "Patient ID", "Partner", "Amount", "Commission", "Status", "Created"]} empty={(orders.data || []).length === 0}>
        {(orders.data || []).map((o) => <tr key={o.id}><Td>{o.ref}<p className="text-xs muted">{o.listing.title}</p></Td><Td>{o.patient_code}</Td><Td>{o.partner_name}</Td><Td>{inr(o.amount)}</Td><Td>{inr(o.commission)}</Td><Td><StatusBadge status={o.status} /></Td><Td>{fmtDT(o.created_at)}</Td></tr>)}
      </Table>
    </div>
  );
}
